import { createServerFn } from "@tanstack/react-start";

import {
  type ConsentChoice,
  consentGroupsSchema,
  type ConsentState,
} from "~/lib/shared/consent";

/** The visitor's region, saved choice and Global Privacy Control signal. */
export const getConsentState = createServerFn({ method: "GET" }).handler(
  async (): Promise<ConsentState> => {
    const { getRequestConsent } = await import("~/lib/server/consent");
    return getRequestConsent();
  },
);

export const saveConsentChoice = createServerFn({ method: "POST" })
  .validator(consentGroupsSchema)
  .handler(async ({ data }): Promise<ConsentChoice> => {
    const { persistConsentChoice } = await import("~/lib/server/consent");
    return persistConsentChoice(data);
  });
